<div class="info-panel">
  <lx-price-lists-portal-currency [currency]="currency"></lx-price-lists-portal-currency>
  <div [ngClass]="'info-panel__panel info-panel__panel--' + company | lowercase">
    <lx-price-lists-portal-more-info-list title="Private courses" [moreInfoItems]="privateLessons"></lx-price-lists-portal-more-info-list>
    <lx-price-lists-portal-notes *ngIf="notes?.length > 0" [notes]="notes" [notationMarks]="notationMarks" [company]="company"></lx-price-lists-portal-notes>
  </div>
</div>
